import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoDocumentoService = {
  getAll,
  insertOrUpdate,
  getAllActive,
  removerById,
}

async function getAll() {
  return await ApiBudgety.get('TipoDocumento/GetAll/')
}

async function getAllActive() {
  return await ApiBudgety.get('TipoDocumento/GetAllActive/')
}

async function insertOrUpdate(body) {
  return await ApiBudgety.post('TipoDocumento/InsertOrUpdate/', body, {
    headers: {
      ACCION: MenusSistema.mantenedor_tipo_documento.accesos.crear_editar_tipo_documento,
      MENU: MenusSistema.mantenedor_tipo_documento.id,
    },
  })
}

async function removerById(id) {
  return await ApiBudgety.post('TipoDocumento/Delete/' + id, null, {
    headers: {
      ACCION: MenusSistema.mantenedor_tipo_documento.accesos.remover_tipo_documento,
      MENU: MenusSistema.mantenedor_tipo_documento.id,
    },
  })
}
